import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Ключ цели отрисовки (§5.3) — человеку. Пропуски у картинок ШТАТНЫ (место
 * исчезло, safety-блок модели), автор видит их часто, а `element:440:base:hero`
 * ему не говорит ничего.
 *
 * Незнакомый префикс отдаём как есть: формат ключей задаёт бэк, и молчаливая
 * пустая строка хуже сырого ключа.
 */
export const imageTargetLabel = (key: string): string => {
  const [kind, id] = key.split(':')
  const m = messagesNow(messages)
  switch (kind) {
    case 'course_banner':
      return m.targetCourseBanner
    case 'mascot':
      return m.targetMascot(id)
    case 'lesson':
      return m.targetLessonImage(id)
    case 'block':
      return m.targetBlockImage(id)
    case 'element':
      // Первый id — id БЛОКА, id элемента идёт последним и может содержать
      // двоеточия (`element:440:base:hero:2`) — в подпись он не нужен.
      return m.targetElement(id)
    default:
      return key
  }
}
